import { observer } from 'mobx-react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Routes } from '../../../../route/Routes';
import {
  useOnboardingChecklistStore,
  useQuestionnaireEvaluationStore,
} from '../../../../store';
import {
  CannabisConsumptionQuestionnaireResult,
  CheckListId,
  CheckListItemType,
} from '@web/common';
import { showErrorNotification } from '../../../../component/notification';
import { CannabisConsumptionQuestionnaireContent } from './CannabisConsumptionQuestionnaireContent';

export const InitialCannabisConsumptionQuestionnaire = observer(() => {
  const onboardingChecklistStore = useOnboardingChecklistStore();
  const questionnaireEvaluationStore = useQuestionnaireEvaluationStore();
  const { state } = useLocation();
  const navigate = useNavigate();
  const checkListItemId =
    state?.id as CheckListId.CannabisConsumptionQuestionnaire | null;

  if (
    !checkListItemId ||
    checkListItemId !== CheckListId.CannabisConsumptionQuestionnaire
  ) {
    return <Navigate to={Routes.Study} />;
  }

  const surveyComplete = (
    surveyResult: CannabisConsumptionQuestionnaireResult,
  ) => {
    Promise.all([
      onboardingChecklistStore.storeQuestionnaireResults({
        id: checkListItemId,
        result: surveyResult,
      }),
      questionnaireEvaluationStore.evaluateCuditQuestionnaire(surveyResult),
    ])
      .then(() => {
        navigate(Routes.Study, {
          state: {
            id: checkListItemId,
            result: surveyResult,
            reoccurrence: 0,
          },
          replace: true,
        });
      })
      .catch(() => showErrorNotification());
  };

  const checkListItem = onboardingChecklistStore.checklist
    ? onboardingChecklistStore.checklist[checkListItemId]
    : null;
  const alreadyAnswered =
    checkListItem?.type ===
      CheckListItemType.QuestionnaireCannabisConsumption &&
    !!checkListItem?.questionnaireResult;

  if (alreadyAnswered) {
    return <Navigate to={Routes.Study} />;
  }

  return (
    <CannabisConsumptionQuestionnaireContent surveyComplete={surveyComplete} />
  );
});
